import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, Share2, Minus, Plus, ShoppingBag, Truck, RotateCcw, Shield, ChevronRight, Star } from 'lucide-react';
import Header from './components/Header25';
import Footer from './components/Footer25';

const ProductDetail25 = () => {
    const navigate = useNavigate();
    const [selectedSize, setSelectedSize] = useState('M');
    const [quantity, setQuantity] = useState(1);
    const [activeTab, setActiveTab] = useState('description');
    const [mainImage, setMainImage] = useState(0);
    const [isWishlisted, setIsWishlisted] = useState(false);

    const product = {
        name: 'Classic Cotton Kurta',
        price: 3499,
        originalPrice: 4999,
        rating: 4.6,
        reviews: 128,
        description: 'A masterfully crafted cotton kurta that brings together traditional Indian craftsmanship and contemporary design sensibility. Made from premium handloom cotton, this kurta features meticulous stitch work and a modern silhouette that transitions effortlessly from casual to semi-formal occasions.',
        images: [
            'https://images.pexels.com/photos/8310281/pexels-photo-8310281.jpeg?auto=compress&cs=tinysrgb&w=800',
            'https://images.pexels.com/photos/6311652/pexels-photo-6311652.jpeg?auto=compress&cs=tinysrgb&w=800',
            'https://images.pexels.com/photos/8953474/pexels-photo-8953474.jpeg?auto=compress&cs=tinysrgb&w=800',
            'https://images.pexels.com/photos/10032879/pexels-photo-10032879.jpeg?auto=compress&cs=tinysrgb&w=800',
        ],
        specs: {
            Fabric: '100% Premium Handloom Cotton',
            Occasion: 'Casual / Semi-Formal',
            Care: 'Machine wash cold, tumble dry low',
            Fit: 'Regular Fit',
            Length: 'Below knee',
            Sleeve: 'Full Sleeve',
            Neck: 'Mandarin Collar',
            Color: 'Off-White with Teal Accents',
        }
    };

    const sizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

    const relatedProducts = [
        { id: 2, name: 'Linen Kurta Pajama', price: 4200, image: 'https://images.pexels.com/photos/6311652/pexels-photo-6311652.jpeg?auto=compress&cs=tinysrgb&w=800' },
        { id: 3, name: 'Structured Nehru Jacket', price: 6500, image: 'https://images.pexels.com/photos/9558577/pexels-photo-9558577.jpeg?auto=compress&cs=tinysrgb&w=800' },
        { id: 4, name: 'Indo-Western Jacket', price: 7800, image: 'https://images.pexels.com/photos/10032879/pexels-photo-10032879.jpeg?auto=compress&cs=tinysrgb&w=800' },
    ];

    const tabs = ['description', 'specifications', 'reviews'];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=IBM+Plex+Sans:wght@300;400;500;600;700&display=swap');
                .sahaj-pd * { box-sizing: border-box; }
                .sahaj-pd { font-family: 'IBM Plex Sans', sans-serif; background: #FFFFFF; color: #111111; }
                .sahaj-pd-heading { font-family: 'Space Grotesk', sans-serif; }
                .sahaj-pd-thumb { border: 2px solid transparent; cursor: pointer; transition: border-color 0.2s; }
                .sahaj-pd-thumb:hover, .sahaj-pd-thumb-active { border-color: #0D7C66; }
                .sahaj-pd-size { width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; border: 1px solid #DEE2E6; cursor: pointer; font-size: 14px; font-weight: 500; transition: all 0.2s; font-family: 'Space Grotesk', sans-serif; }
                .sahaj-pd-size:hover { border-color: #0D7C66; }
                .sahaj-pd-size-active { background: #0D7C66; color: #FFFFFF; border-color: #0D7C66; }
                .sahaj-pd-tab { padding: 12px 24px; border: none; background: none; cursor: pointer; font-size: 14px; font-weight: 500; color: #6C757D; border-bottom: 2px solid transparent; transition: all 0.2s; font-family: 'Space Grotesk', sans-serif; text-transform: uppercase; letter-spacing: 1px; }
                .sahaj-pd-tab:hover { color: #111111; }
                .sahaj-pd-tab-active { color: #0D7C66; border-bottom-color: #0D7C66; }
            `}</style>
            <div className="sahaj-pd" style={{ minHeight: '100vh' }}>
                <Header />

                {/* Breadcrumb */}
                <div style={{ maxWidth: 1280, margin: '0 auto', padding: '100px 24px 0' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#6C757D', marginBottom: 40 }}>
                        <span style={{ cursor: 'pointer' }} onClick={() => navigate('/template25')}>Home</span>
                        <ChevronRight size={14} />
                        <span style={{ cursor: 'pointer' }} onClick={() => navigate('/template25/shop')}>Shop</span>
                        <ChevronRight size={14} />
                        <span style={{ color: '#111111', fontWeight: 500 }}>{product.name}</span>
                    </div>

                    {/* Product Section */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 60, marginBottom: 80 }}>
                        {/* Gallery */}
                        <div style={{ display: 'flex', gap: 16 }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                                {product.images.map((img, idx) => (
                                    <div
                                        key={idx}
                                        className={`sahaj-pd-thumb ${mainImage === idx ? 'sahaj-pd-thumb-active' : ''}`}
                                        onClick={() => setMainImage(idx)}
                                        style={{ width: 80, height: 80, overflow: 'hidden' }}
                                    >
                                        <img src={img} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    </div>
                                ))}
                            </div>
                            <div style={{ flex: 1, aspectRatio: '1/1', overflow: 'hidden' }}>
                                <img
                                    src={product.images[mainImage]}
                                    alt={product.name}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            </div>
                        </div>

                        {/* Details */}
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                                <div style={{ display: 'flex', gap: 2 }}>
                                    {[1,2,3,4,5].map(s => (
                                        <Star key={s} size={14} fill={s <= Math.floor(product.rating) ? '#0D7C66' : 'none'} color="#0D7C66" />
                                    ))}
                                </div>
                                <span style={{ fontSize: 13, color: '#6C757D' }}>{product.rating} ({product.reviews} reviews)</span>
                            </div>

                            <h1 className="sahaj-pd-heading" style={{
                                fontSize: 36, fontWeight: 700, margin: '0 0 16px', letterSpacing: '-0.5px', lineHeight: 1.1
                            }}>
                                {product.name}
                            </h1>

                            <div style={{ display: 'flex', alignItems: 'baseline', gap: 16, marginBottom: 24 }}>
                                <span className="sahaj-pd-heading" style={{ fontSize: 32, fontWeight: 700 }}>
                                    ₹{product.price.toLocaleString('en-IN')}
                                </span>
                                <span style={{ fontSize: 18, color: '#6C757D', textDecoration: 'line-through' }}>
                                    ₹{product.originalPrice.toLocaleString('en-IN')}
                                </span>
                                <span style={{
                                    padding: '4px 12px', background: '#E8F5F1', color: '#0D7C66',
                                    fontSize: 13, fontWeight: 600
                                }}>
                                    {Math.round((1 - product.price / product.originalPrice) * 100)}% OFF
                                </span>
                            </div>

                            <p style={{ fontSize: 15, color: '#6C757D', lineHeight: 1.7, marginBottom: 32 }}>
                                {product.description}
                            </p>

                            {/* Size Selector */}
                            <div style={{ marginBottom: 32 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                    <span style={{ fontSize: 13, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px' }}>Size</span>
                                    <span style={{ fontSize: 13, color: '#0D7C66', cursor: 'pointer', fontWeight: 500 }}>Size Guide</span>
                                </div>
                                <div style={{ display: 'flex', gap: 8 }}>
                                    {sizes.map(size => (
                                        <button
                                            key={size}
                                            onClick={() => setSelectedSize(size)}
                                            className={`sahaj-pd-size ${selectedSize === size ? 'sahaj-pd-size-active' : ''}`}
                                        >
                                            {size}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* Quantity */}
                            <div style={{ marginBottom: 32 }}>
                                <span style={{ fontSize: 13, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: 12 }}>
                                    Quantity
                                </span>
                                <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #DEE2E6', width: 'fit-content' }}>
                                    <button
                                        onClick={() => setQuantity(Math.max(1, quantity - 1))}
                                        style={{ width: 48, height: 48, border: 'none', background: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    >
                                        <Minus size={16} />
                                    </button>
                                    <span className="sahaj-pd-heading" style={{ width: 60, textAlign: 'center', fontSize: 16, fontWeight: 600 }}>
                                        {quantity}
                                    </span>
                                    <button
                                        onClick={() => setQuantity(quantity + 1)}
                                        style={{ width: 48, height: 48, border: 'none', background: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    >
                                        <Plus size={16} />
                                    </button>
                                </div>
                            </div>

                            {/* Actions */}
                            <div style={{ display: 'flex', gap: 12, marginBottom: 32 }}>
                                <button
                                    onClick={() => navigate('/template25/cart')}
                                    style={{
                                        flex: 1, padding: '16px 32px', background: '#0D7C66', color: '#FFFFFF',
                                        border: 'none', fontSize: 14, fontWeight: 700, cursor: 'pointer',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
                                        textTransform: 'uppercase', letterSpacing: '2px',
                                        fontFamily: 'Space Grotesk, sans-serif',
                                        transition: 'background 0.2s'
                                    }}
                                    onMouseEnter={e => e.target.style.background = '#0A9B7F'}
                                    onMouseLeave={e => e.target.style.background = '#0D7C66'}
                                >
                                    <ShoppingBag size={18} />
                                    ADD TO CART
                                </button>
                                <button
                                    onClick={() => setIsWishlisted(!isWishlisted)}
                                    style={{
                                        width: 56, height: 56, border: '1px solid #DEE2E6', background: '#FFFFFF',
                                        cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        transition: 'border-color 0.2s'
                                    }}
                                >
                                    <Heart size={20} fill={isWishlisted ? '#0D7C66' : 'none'} color={isWishlisted ? '#0D7C66' : '#111111'} />
                                </button>
                                <button style={{
                                    width: 56, height: 56, border: '1px solid #DEE2E6', background: '#FFFFFF',
                                    cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <Share2 size={20} color="#111111" />
                                </button>
                            </div>

                            {/* Trust Badges */}
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, padding: '24px 0', borderTop: '1px solid #DEE2E6' }}>
                                {[
                                    { icon: Truck, text: 'Free Shipping', sub: 'Orders above ₹2,000' },
                                    { icon: RotateCcw, text: 'Easy Returns', sub: '15-day return policy' },
                                    { icon: Shield, text: 'Authentic', sub: 'Quality guaranteed' },
                                ].map((item, idx) => (
                                    <div key={idx} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                        <item.icon size={20} color="#0D7C66" style={{ marginBottom: 8 }} />
                                        <span style={{ fontSize: 12, fontWeight: 600, marginBottom: 2 }}>{item.text}</span>
                                        <span style={{ fontSize: 11, color: '#6C757D' }}>{item.sub}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Tabs */}
                    <div style={{ borderBottom: '1px solid #DEE2E6', marginBottom: 40 }}>
                        <div style={{ display: 'flex' }}>
                            {tabs.map(tab => (
                                <button
                                    key={tab}
                                    onClick={() => setActiveTab(tab)}
                                    className={`sahaj-pd-tab ${activeTab === tab ? 'sahaj-pd-tab-active' : ''}`}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Tab Content */}
                    <div style={{ marginBottom: 80, maxWidth: 800 }}>
                        {activeTab === 'description' && (
                            <div>
                                <p style={{ fontSize: 15, lineHeight: 1.8, color: '#6C757D' }}>{product.description}</p>
                                <p style={{ fontSize: 15, lineHeight: 1.8, color: '#6C757D', marginTop: 16 }}>
                                    Each piece is individually inspected for quality and crafted by skilled artisans who have honed their craft over generations. The subtle teal accents add a contemporary touch to this timeless garment.
                                </p>
                            </div>
                        )}
                        {activeTab === 'specifications' && (
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <tbody>
                                    {Object.entries(product.specs).map(([key, value], idx) => (
                                        <tr key={key} style={{ borderBottom: '1px solid #DEE2E6' }}>
                                            <td className="sahaj-pd-heading" style={{
                                                padding: '14px 0', fontSize: 14, fontWeight: 600,
                                                width: 180, color: '#111111'
                                            }}>
                                                {key}
                                            </td>
                                            <td style={{ padding: '14px 0', fontSize: 14, color: '#6C757D' }}>
                                                {value}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                        {activeTab === 'reviews' && (
                            <div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 32 }}>
                                    <span className="sahaj-pd-heading" style={{ fontSize: 48, fontWeight: 700 }}>{product.rating}</span>
                                    <div>
                                        <div style={{ display: 'flex', gap: 2, marginBottom: 4 }}>
                                            {[1,2,3,4,5].map(s => (
                                                <Star key={s} size={16} fill={s <= Math.floor(product.rating) ? '#0D7C66' : 'none'} color="#0D7C66" />
                                            ))}
                                        </div>
                                        <span style={{ fontSize: 13, color: '#6C757D' }}>Based on {product.reviews} reviews</span>
                                    </div>
                                </div>
                                {[
                                    { name: 'Arjun M.', rating: 5, text: 'Exceptional quality cotton. The fit is perfect and the mandarin collar gives it a distinguished look. Worth every rupee.', date: '2 weeks ago' },
                                    { name: 'Priya S.', rating: 4, text: 'Beautiful kurta with great attention to detail. The teal accents are subtle yet striking. Slightly long for my height.', date: '1 month ago' },
                                ].map((review, idx) => (
                                    <div key={idx} style={{ padding: '24px 0', borderBottom: '1px solid #DEE2E6' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                                            <div>
                                                <span className="sahaj-pd-heading" style={{ fontWeight: 600, marginRight: 12 }}>{review.name}</span>
                                                <span style={{ display: 'inline-flex', gap: 2 }}>
                                                    {[1,2,3,4,5].map(s => (
                                                        <Star key={s} size={12} fill={s <= review.rating ? '#0D7C66' : 'none'} color="#0D7C66" />
                                                    ))}
                                                </span>
                                            </div>
                                            <span style={{ fontSize: 13, color: '#6C757D' }}>{review.date}</span>
                                        </div>
                                        <p style={{ fontSize: 14, lineHeight: 1.6, color: '#6C757D', margin: 0 }}>{review.text}</p>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Related Products */}
                    <div style={{ marginBottom: 80 }}>
                        <h2 className="sahaj-pd-heading" style={{ fontSize: 28, fontWeight: 700, marginBottom: 32, letterSpacing: '-0.5px' }}>
                            YOU MAY ALSO LIKE
                        </h2>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
                            {relatedProducts.map(item => (
                                <div
                                    key={item.id}
                                    style={{ cursor: 'pointer', border: '1px solid #DEE2E6', transition: 'box-shadow 0.3s' }}
                                    onClick={() => navigate('/template25/product')}
                                >
                                    <div style={{ aspectRatio: '1/1', overflow: 'hidden' }}>
                                        <img src={item.image} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    </div>
                                    <div style={{ padding: 16 }}>
                                        <h3 className="sahaj-pd-heading" style={{ fontSize: 16, fontWeight: 600, margin: '0 0 8px' }}>{item.name}</h3>
                                        <p className="sahaj-pd-heading" style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>₹{item.price.toLocaleString('en-IN')}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default ProductDetail25;
